import {
  Users,
  Gauge,
  FileText,
  CreditCard,
  MessageSquare,
  Database,
  Building2,
  Settings,
  Wrench,
} from "lucide-react";

// Add your feature-specific utilities here
export const onboardingDataMigrationApi = {};

// Category metadata - maps API category names to UI enhancements
export const CATEGORY_METADATA: Record<
  string,
  {
    icon: React.ElementType;
    description: string;
    id: string;
  }
> = {
  "Consumer Management": {
    icon: Users,
    description: "Customer accounts, profiles, and related information",
    id: "consumer-management",
  },
  "Meter Management": {
    icon: Gauge,
    description: "Water meters, readings, and consumption tracking",
    id: "meter-management",
  },
  "Asset Management": {
    icon: Building2,
    description: "Infrastructure, facilities, and equipment management",
    id: "asset-management",
  },
  "Organisation Setup": {
    icon: Settings,
    description: "Plans, configurations, and organizational settings",
    id: "organisation-setup",
  },
  "Service Management": {
    icon: Wrench,
    description: "Service requests and work orders",
    id: "service-management",
  },
};

// Data type metadata - maps API data type names to UI enhancements
export const DATATYPE_METADATA: Record<
  string,
  {
    icon: string;
  }
> = {
  Consumers: {
    icon: "Users",
  },
  "Consumer Meter Mapping": {
    icon: "Gauge",
  },
  Payments: {
    icon: "CreditCard",
  },
  Meters: {
    icon: "Gauge",
  },
  "Meter Reading": {
    icon: "Database",
  },
  Assets: {
    icon: "Building2",
  },
  "Asset Classification": {
    icon: "Settings",
  },
  Facilities: {
    icon: "Building2",
  },
  Systems: {
    icon: "Settings",
  },
  "System Types": {
    icon: "Settings",
  },
  Networks: {
    icon: "Building2",
  },
  Plans: {
    icon: "FileText",
  },
  "Service Orders": {
    icon: "ClipboardList",
  },
  Complaints: {
    icon: "MessageSquare",
  },
};

// Default fallbacks
export const DEFAULT_CATEGORY_META = {
  icon: Settings,
  description: "Data management and configuration",
  id: "default-category",
};

export const DEFAULT_DATATYPE_META = {
  icon: "Database",
};
